import { render, staticRenderFns } from "./profile-actions.vue?vue&type=template&id=6250ce82"
import script from "./profile-actions.vue?vue&type=script&lang=js"
export * from "./profile-actions.vue?vue&type=script&lang=js"
import style0 from "./profile-actions.vue?vue&type=style&index=0&id=6250ce82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/app/components/ui/button/c-btn.vue').default,IconMessage: require('/app/components/icons/IconMessage.vue').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default})


/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
